import { useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import PageLayout from '@/components/layout/page-layout'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { useFirebaseUser } from '@/hooks/useFirebaseUser'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { SettingsActions } from '@/redux/reducers/settings'

export const Route = createFileRoute('/_authenticated/(developer)/debug')({
  component: DebugPage,
})

function DebugPage() {
  const { reloadUser } = useFirebaseUser()
  const queryClient = useQueryClient()
  const dispatch = useAppDispatch()
  const minimizeEmptyColumns = useAppSelector(state => state.settings.minimizeEmptyColumns)

  return (
    <PageLayout title="Debug">
      <div className="card flex flex-col gap-8 [&_>_div]:space-y-2">
        <div>
          <Button onClick={reloadUser} size="lg">
            Reload user
          </Button>
          <p>Reloads user claims and tokens, may fix auth issues.</p>
        </div>
        <div>
          <Button onClick={() => queryClient.invalidateQueries()} size="lg">
            Reload data
          </Button>
          <p>Reloads all queries in the React Query client, may fix stale data issues.</p>
        </div>
        <div>
          <label className="flex items-center gap-3">
            <Switch
              checked={minimizeEmptyColumns}
              onCheckedChange={checked =>
                dispatch(SettingsActions.setMinimizeEmptyColumns(checked))
              }
            />
            <span>Minimize empty columns</span>
          </label>
          <p>Shrinks empty columns on horizontal kanban boards to save space.</p>
        </div>
      </div>
    </PageLayout>
  )
}
